import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";

const included = [
	"Job stays live until deadline or 30 days",
	"Unlimited deadline edits within 30 days",
	"A dedicated company hiring page",
	"Promotion across our job board, socials, WhatsApp, and email digest",
	"Optional 30-day extension for 29,000 TZS",
];

const noStrings = ["No monthly subscription", "No per-candidate fees", "No account required"];

function PricingSection() {
	return (
		<motion.section
			className="py-14 sm:py-20"
			initial={{ opacity: 0, y: 24 }}
			whileInView={{ opacity: 1, y: 0 }}
			viewport={{ once: true, margin: "-64px" }}
			transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
		>
			<div className="max-w-6xl mx-auto px-4">
				<div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
					{/* Left — copy */}
					<div>
						<p className="font-inter text-xs font-semibold text-blue-600 tracking-[0.15em] uppercase mb-4">Pricing</p>
						<h2 className="font-plus-jakarta text-[clamp(1.75rem,4vw,2.75rem)] font-bold text-gray-900 tracking-tight leading-tight mb-6">
							One flat fee.
							<br />
							Everything included.
						</h2>
						<p className="font-inter text-gray-500 leading-relaxed max-w-md mb-8">
							No setup costs. No monthly subscription. Post a job and reach qualified candidates across Tanzania.
						</p>

						<div className="flex flex-wrap gap-2.5">
							{noStrings.map((item) => (
								<span
									key={item}
									className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-green-50 font-inter text-sm text-green-700 font-medium"
								>
									<Check className="w-3.5 h-3.5" />
									{item}
								</span>
							))}
						</div>
					</div>

					{/* Right — pricing card */}
					<div className="bg-white border border-gray-200 rounded-2xl p-7 sm:p-9 shadow-sm">
						<span className="inline-block font-inter text-xs font-semibold text-blue-600 tracking-[0.15em] uppercase mb-5">
							Per Job Post
						</span>
						<div className="flex items-baseline gap-2 mb-8">
							<span className="font-plus-jakarta text-5xl sm:text-6xl font-extrabold text-gray-900 tracking-tight">
								49k
							</span>
							<span className="font-inter text-sm text-gray-400">TZS</span>
						</div>
						<div className="w-full h-px bg-gray-100 mb-8" />
						<ul className="space-y-4">
							{included.map((feature) => (
								<li key={feature} className="flex items-start gap-3">
									<div className="shrink-0 mt-0.5 w-5 h-5 rounded-full bg-blue-50 flex items-center justify-center">
										<Check className="w-3 h-3 text-blue-600" />
									</div>
									<span className="font-inter text-sm text-gray-600 leading-relaxed">{feature}</span>
								</li>
							))}
						</ul>
					</div>
				</div>
			</div>
		</motion.section>
	);
}

export default PricingSection;
